import {LOAD_SERVICES,LOAD_SUB_SERVICES,SERVICES_LOADING} from './types';
const initialState = {
    loading:false,
    services:[],
    sub_services:[]
};
export const reducer = (state = initialState,action) => {
    switch(action.type){
        case SERVICES_LOADING:
            return {
                ...state,
                loading:true
            }
        case LOAD_SUB_SERVICES:
            return {
                ...state,
                sub_services:action.payload,
                loading:false
            }
        case LOAD_SERVICES:
            return {
                ...state,
                services:action.payload,
                loading:false
            }
        default:
            return {
                ...state
            }
    };
};